module.exports = __webpack_public_path__ + "img/17.5COD.a8ed18ff.png";